namespace SP {



    interface StockPlacmentPickerSettingsInterface {
        onSelect: (id: number) => void;
    }

    export class StockPlacementPicker {
        hallPicker: HTMLSelectElement;
        unitPicker: HTMLSelectElement;
        placementPicker: HTMLSelectElement;
        currentCustomerId: string;
        container: HTMLElement;
        settings: StockPlacmentPickerSettingsInterface;
        _value: number;

        get value(): number {
            return this._value;
        }

        set value(val: number) {
            this.setValue(val);
        }

        get locationName(): string {
            return this.hallPicker.selectedOptions[0].innerHTML +
                " - " + this.unitPicker.selectedOptions[0].innerHTML +
                " - " + this.placementPicker.selectedOptions[0].innerHTML;
        }

        async setValue(placementId: number) {
            if (!placementId.toString().length) {
                console.error("null");
                return;

            }
            if (this._value == placementId) return;
            this._value = placementId;
            this.settings.onSelect(placementId);

            console.log("setting placemetnID", placementId);
            let info = await Data.Stock.getPlacementInfo(placementId);
            this.currentCustomerId = info.stock.stockId;

            if (this.hallPicker.value != info.hall.id) {
                await this.setHallDropDown();
                this.hallPicker.value = info.hall.id;
            }

            if (this.unitPicker.value != info.unit.id) {
                var result = await this.setUnitDropDown();
                this.unitPicker.value = info.unit.id;
            }

            if (this.placementPicker.value != info.placement.id.toString()) {
                await this.setPlacementDropDown();
                this.placementPicker.value = info.placement.id.toString();
            }


        }

        constructor(containerQuerySelector: string, settings: StockPlacmentPickerSettingsInterface) {
            this.settings = settings;
            this.container = document.querySelector(containerQuerySelector);
            this.hallPicker = this.container.appendChild(document.createElement("select"));
            this.unitPicker = this.container.appendChild(document.createElement("select"));
            this.placementPicker = this.container.appendChild(document.createElement("select"));

            this.hallPicker.addEventListener("change", () => {
                this.setUnitDropDown();
            });
            this.unitPicker.addEventListener("change", () => {
                this.setPlacementDropDown();
            });
            this.placementPicker.addEventListener("change", () => {
                this._value = parseInt(this.placementPicker.value);
                this.settings.onSelect(this._value);
            });

            if (settings.onSelect == null) settings.onSelect = id => { console.log("select location id:", id); };
        }

        resetHallPicker() {
            this.hallPicker.length = 0;
            this.hallPicker.appendChild(SP.createElement("option", { text: SP.Localize("word_hall"), value: "" }));
        }

        resetUnitPicker() {
            this.unitPicker.length = 0;
            this.unitPicker.appendChild(SP.createElement("option", { text: SP.Localize("word_unit"), value: "" }));
        }

        resetPlacementPicker() {
            this.placementPicker.length = 0;
            this.placementPicker.appendChild(SP.createElement("option", { text: SP.Localize("word_place"), value: "" }));
        }

        reset() {
            this._value = null;
            this.resetHallPicker();
            this.resetUnitPicker();
            this.resetPlacementPicker();
        }

        async setCustomer(customerId: string) {
            if (this.currentCustomerId != customerId) {
                this.reset();
                this.currentCustomerId = customerId;
                await this.setHallDropDown();
            }
        }

        async setHallDropDown() {
            this.reset();
            let customerInfo = await Data.Customer.getCustomerInfo(this.currentCustomerId);
            let halls = await Data.Stock.getHalls(customerInfo.stockId);
            halls.forEach(hall => {
                let option = SP.createElement("option", { text: SP.Localize("word_hall") + " " + hall.name, value: hall.id }) as HTMLOptionElement;
                this.hallPicker.appendChild(option);
            });
        }

        async setUnitDropDown() {
            this.resetUnitPicker();
            this.resetPlacementPicker();
            let hallId = this.hallPicker.value;
            if (hallId.length) {
                let sections = await Data.Stock.getSections(hallId);

                for (let i = 0; i < sections.length; i++) {
                    let section = sections[i];
                    let units = await Data.Stock.getUnits(section.id)
                    units.forEach(unit => {
                        let option = SP.createElement("option", { text: section.name + unit.number.toString().padStart(2, "0"), value: unit.id });
                        this.unitPicker.appendChild(option);
                    });
                }
            }
        }

        async setPlacementDropDown() {
            this.resetPlacementPicker();
            let unitId = this.unitPicker.value;
            if (unitId.length) {
                let placements = await Data.Stock.getPlacements(unitId);
                placements.forEach(placement => {
                    let option = SP.createElement("option", { text: placement.row.toString().padStart(2, "0") + " - " + placement.number.toString().padStart(2, "0"), value: placement.id });
                    this.placementPicker.appendChild(option);
                });
            }
        }
    }
}